module.exports = __webpack_public_path__ + "static/mpost79.43ada046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost79.jpg
// module id = 258
// module chunks = 23899280101116 35783957827783